import { render, staticRenderFns } from "./delete-csv.vue?vue&type=template&id=628d41f2&scoped=true&"
import script from "./delete-csv.vue?vue&type=script&lang=js&"
export * from "./delete-csv.vue?vue&type=script&lang=js&"
import style0 from "./delete-csv.vue?vue&type=style&index=0&id=628d41f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628d41f2",
  null
  
)

export default component.exports